<template>
  <tr
    class="table-row"
    :class="{
      'table-row-selected': selected
    }"
    @click="onClickSelected">
    <td class="table-cell"
      v-if="showInternalId">
      {{ item.student.internal_id }}
    </td>
    <td>{{ item.student.public_id }}</td>
    <td>{{ item.student.first_name }}</td>
    <td>{{ item.student.last_name }}</td>
    <td>{{ vehicleDisplay }}</td>
    <td>{{ submissionDateDisplay }}</td>
    <td>{{ eventDateDisplay }}</td>
    <td>{{ directionDisplay }}</td>
  </tr>
</template>

<script>
export default {
  components: {},
  props: {
    item: Object,
    selected: Boolean,
    showInternalId: Boolean,
  },
  data() {
    return {
      open: false,
      directions: {
        I: 'Inbound',
        O: 'Outbound',
        B: 'Both',
      },
    }
  },
  methods: {
    async toggleDetails() {
      if (!this.open) {
        // do something
      }
      this.open = !this.open
    },
    clickEvent() {
      // add other pure events on the student item here
    },
    onClickSelected() {
      this.$emit('changeSelected', this.item.id)

      // do something
    },
    onClickExpand() {
      if (this.open) {
        setTimeout(this.toggleDetails, 0)
      }
    },
  },
  computed: {
    dateDisplay() {
      if (!this.item.event_date) return ''

      return new Date(this.item.event_date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'UTC',
      })
    },
    directionDisplay() {
      if (this.item === undefined) return ''

      return this.directions[this.item.event_type]
    },
    vehicleDisplay() {
      if (this.item.vehicle) {
        return this.item.vehicle.code
      }
      else {
        return '---'
      }
    },
    submissionDateDisplay() {
      if (this.item.submitted_at){
        return new Date(this.item.submitted_at).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
      } else {
        return new Date(this.item.created_at).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
      }
    },
    eventDateDisplay() {
      if (!this.item.event_date) return ''

      return new Date(this.item.event_date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'UTC',
      })
    },
  },
  watch: {
    selected: async function () {
      if (!this.selected) {
        this.open = false
      }
    },
  },
  async created() {
    if (this.selected) {
      this.toggleDetails()
    }
  },
}
</script>

<style></style>
